import { createNode } from '@glueapp/graph-types';

export const SplitText = createNode({
    id: 'Split Text',
    name: 'Split Text',
    description:
        'Splits the text into a list of texts based on the separator. So for example if the Input text is "Batman" and the Separator is "t" the output will be a list containing "Ba" and "man"',
    aiDescription:
        'Splits a string into an array of strings by a separator. Connect the source string to "Input" and the delimiter to "Separator"; outputs a string array on "Output".',
    category: 'Text',
    color: '#387cc8',
    integration: undefined,
    inPorts: {
        Input: { kind: 'string' },
        Separator: { kind: 'string' },
    },
    outPorts: {
        Output: {
            kind: 'array',
            subType: {
                kind: 'string',
            },
        },
    },
    execute: function (input) {
        return { output: { Output: input.inPorts.Input.split(input.inPorts.Separator) } };
    },
});
